module.exports = __webpack_public_path__ + "img/icons8-toyota.542be4f0.svg";